import { render, staticRenderFns } from "./VImagePopup.vue?vue&type=template&id=096f8360"
import script from "./VImagePopup.vue?vue&type=script&lang=js"
export * from "./VImagePopup.vue?vue&type=script&lang=js"
import style0 from "./VImagePopup.vue?vue&type=style&index=0&id=096f8360&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports